module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isStandalone()) { ;
__p += '\n<div id="standalone_header">\n    <div id="header_nav">\n        ';
 if (shouldShowLogoImage()) { ;
__p += '\n        <a href="' +
((__t = ( getLogoRedirectURL() )) == null ? '' : __t) +
'" id="brand_logo" target="_blank" style="' +
((__t = (getLogoImage())) == null ? '' : __t) +
'"></a>\n        ';
 } ;
__p += '\n        <div id="social_profiles_container">\n            <a href="' +
((__t = ( getInstagramURL() )) == null ? '' : __t) +
'" class="social_profile_icons" id="instagram_profile" target="_blank"\n                title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'"></a>\n            <a href="' +
((__t = ( getTwitterURL() )) == null ? '' : __t) +
'" class="social_profile_icons" id="twitter_profile" target="_blank"\n                title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'"></a>\n            <a href="' +
((__t = ( getPinterestURL() )) == null ? '' : __t) +
'" class="social_profile_icons" id="pinterest_profile" target="_blank"\n                title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'"></a>\n            <a href="' +
((__t = ( getFacebookURL() )) == null ? '' : __t) +
'" class="social_profile_icons" id="facebook_profile" target="_blank"\n                title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'"></a>\n        </div>\n    </div>\n    ';
 if (shouldShowBannerImage()) { ;
__p += '\n    <div id="banner_image" style="' +
((__t = ( getBannerImage())) == null ? '' : __t) +
'">\n        <img src="' +
((__t = ( getBannerImageURL())) == null ? '' : __t) +
'">\n        <a id="banner_image_link" href="' +
((__t = ( getBannerRedirectURL() )) == null ? '' : __t) +
'" target="_blank"\n            title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'"></a>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';
 } ;
__p += '\n\n\n';
 if(isHeaderV2()) {;
__p += '\n<!-- button classes: uploader_button, uploader_text_w_icon, uploader_text_inline -->\n<!-- header classes: justified, centered, side, tile, vertical_left_aligned -->\n';
 if (!isStandalone() && getHeaderBannerImage()) { ;
__p += '\n<div id="header_banner_image">\n    <img src="' +
((__t = ( getHeaderBannerImage() )) == null ? '' : __t) +
'">\n</div>\n';
 } ;
__p += '\n\n';
if(!isTile()){;
__p += '\n<header id="header_wrapper" ';
 if (_.isTruthy(getHeaderTitle()) || (getLayoutClass() === 'justified' && getButtonClass() === 'uploader_button')) { ;
__p += 'aria-labelledby="hashtag_holder"';
 } ;
__p += '\n    class="' +
((__t = (getWidgetType())) == null ? '' : __t) +
' ' +
((__t = (getLayoutClass())) == null ? '' : __t) +
' ' +
((__t = (getButtonClass())) == null ? '' : __t) +
' ' +
((__t = ( addClassIfTrue(!showDescription(),'no_description') )) == null ? '' : __t) +
'"\n    style="visibility:hidden">\n    ';
 if (_.isTruthy(getHeaderTitle())) { ;
__p += '\n    <h2 id="hashtag_holder">' +
((__t = ( decode_utf8(getHeaderTitle()) )) == null ? '' : __t) +
'</h2>\n    ';
 } else if (getLayoutClass() === 'justified' && getButtonClass() === 'uploader_button') { ;
__p += '\n    <!-- fix button cut-off bug with the above conditions -->\n    <div id="hashtag_holder">&nbsp;</div>\n    ';
 } ;
__p += '\n\n    ';
 if (showDescription()) { ;
__p += '\n    <p id="description_holder">\n        ' +
((__t = ( isDefaultHeaderDescription() ? I18n.t('widget.header.description') : decode_utf8(getHeaderDescription()) )) == null ? '' : __t) +
'\n    </p>\n    ';
 } ;
__p += '\n\n    ';
 if (hasTOS) { ;
__p += '\n    <button type="button" id="upload_now" ';
 if (showDescription()) { ;
__p += 'aria-describedby="description_holder"';
 } ;
__p += '>\n        <span></span>\n        ' +
((__t = ( I18n.t('widget.upload_now') )) == null ? '' : __t) +
'\n    </button>\n    ';
 } ;
__p += '\n\n\n    ';
if (isViewGallery()) {;
__p += '\n    <a href="' +
((__t = (getViewGalleryUrl())) == null ? '' : __t) +
'" target="_blank" id="view_gallery" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'">\n        ' +
((__t = ( isDefaultViewGalleryText() ? I18n.t('widget.header.view_gallery') : decode_utf8(getViewGalleryText()) )) == null ? '' : __t) +
'\n    </a>\n    ';
 } ;
__p += '\n\n    <p class="screen_reader_only">' +
((__t = ( I18n.t('widget.screen_reader_only.header') )) == null ? '' : __t) +
'</p>\n</header>\n';
 } ;
__p += '\n';
} else { ;
__p += '\n<header id="common_header" aria-label="' +
((__t = ( I18n.t('widget.screen_reader_only.header_label') )) == null ? '' : __t) +
'">\n    <ul id="hashtag_holder" role="none">\n        ';
 _.each(gon.collect_string,function(element, index, list) { ;
__p += '\n        <li>' +
((__t = ( element )) == null ? '' : __t) +
'</li>\n        ';
 }) ;
__p += '\n    </ul>\n    <p id="description_holder">\n        ';
 if (typeof isPdpCaption == 'function' && isPdpCaption()) { ;
__p += '\n        ' +
((__t = ( getPdpCaption() )) == null ? '' : __t) +
'\n        ';
 };
__p += '\n\n        ';
 if (!_.isFalsy(description)) { ;
__p += '\n        ' +
((__t = ( Pixlee.request("decode:utf8",description) )) == null ? '' : __t) +
'\n        ';
} ;
__p += '\n    </p>\n    ';
 if (hasTOS) { ;
__p += '\n    <button type="button" id="upload_now" aria-describedby="description_holder">' +
((__t = ( I18n.t('widget.upload_now') )) == null ? '' : __t) +
'</button>\n    ';
 } ;
__p += '\n    ';
 if (isViewGallery()) { ;
__p += '\n    <a href="' +
((__t = (getViewGalleryUrl())) == null ? '' : __t) +
'" target="_blank" id="view_gallery" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'">\n        ' +
((__t = ( isDefaultViewGalleryText() ? I18n.t('widget.header.view_gallery') : getViewGalleryText() )) == null ? '' : __t) +
'\n    </a>\n    ';
 } ;
__p += '\n</header>\n';
};
__p += '\n';

}
return __p
}